export const LOB_LABELS: Record<string, string> = {
  PA: "Personal Auto",
  PU: "Personal Umbrella",
  HO: "HomeOwners",
  BO: "BusinessOwners",
  FO: "FarmOwners",
};

export const SUBTYPE_LABELS: Record<string, string> = {
  AddDriver: "Driver Addition",
  RemoveDriver: "Driver Removal",
  AddVehicleFinanceCompany: "Lienholder Addition",
  RemoveVehicle: "Vehicle Removal",
  AddVehicle: "Vehicle Addition",
};
export const getSubTypeKey = (subType: string) => {
  const match = subType.match(/Policy Change Request: (.+)/);
  return match ? match[1] : subType;
};

export const getPieChartData = (
  customerActivityGroup: any,
  selectedAnalyticsType: number,
  selectedSession?: { customer: string; sessionId: string } | null
) => {
  const counts: Record<string, number> = {};

  if (selectedSession) {
    // Only use the selected session's activities
    const activities =
      customerActivityGroup[selectedSession.customer]?.[
        selectedSession.sessionId
      ] || [];
    activities.forEach((activity: any) => {
      if (selectedAnalyticsType === 0 && activity.category === "Claim") {
        const key = activity.lobCode || "Unknown";
        counts[key] = (counts[key] || 0) + 1;
      } else if (
        selectedAnalyticsType === 1 &&
        activity.category === "Policy"
      ) {
        const key = getSubTypeKey(activity.subType);
        counts[key] = (counts[key] || 0) + 1;
      }
    });
  } else {
    // Use all activities
    customerActivityGroup &&
      Object.values(customerActivityGroup).forEach((sessions: any) => {
        sessions &&
          Object.values(sessions).forEach((activities: any) => {
            activities.forEach((activity: any) => {
              if (
                selectedAnalyticsType === 0 &&
                activity.category === "Claim"
              ) {
                const key = activity.lobCode || "Unknown";
                counts[key] = (counts[key] || 0) + 1;
              } else if (
                selectedAnalyticsType === 1 &&
                activity.category === "Policy"
              ) {
                const key = getSubTypeKey(activity.subType);
                counts[key] = (counts[key] || 0) + 1;
              }
            });
          });
      });
  }

  if (selectedAnalyticsType === 0) {
    return Object.entries(counts).map(([key, value]) => ({
      name: LOB_LABELS[key] || key,
      value,
    }));
  } else {
    return Object.entries(counts).map(([key, value]) => ({
      name: SUBTYPE_LABELS[key] || key,
      value,
    }));
  }
};

export const getPieChartTitle = (selectedAnalyticsType: number) =>
  selectedAnalyticsType === 0
    ? "Claims by Line of Business"
    : "Policy Changes by Type";

export const getPieChartColors = (selectedAnalyticsType: number) =>
  selectedAnalyticsType === 0
    ? ["#7C2AE8", "#A259F7", "#C084FC", "#DDD6FE", "#E9D5FF"]
    : ["#1E3A8A", "#2563EB", "#3B82F6", "#60A5FA", "#93C5FD"];
